import { gql } from '@apollo/client';

export const DELETE_NOT_REGISTERED_ANIMALS = gql`
  mutation deleteNotRegisteredAnimals($id: ID!) {
    deleteNotRegisteredAnimals(id: $id)
  }
`;
